import { render } from "./ProductivityTable.vue?vue&type=template&id=333650cc&scoped=true"
import script from "./ProductivityTable.vue?vue&type=script&lang=js"
export * from "./ProductivityTable.vue?vue&type=script&lang=js"

import "./ProductivityTable.vue?vue&type=style&index=0&id=333650cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333650cc"]])

export default __exports__